import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { decodeCategoryNames } from './decodeCategoryNames';
import { BUILD_CATEGORIE_RESTRICTION_TREE } from './gql/buildCategorieRestrictionTree';

type QueryDataType = Pick<Query, 'buildCategorieRestrictionTree'>;
type OutgoingDataType = QueryDataType['buildCategorieRestrictionTree'];

const onError = getErrorLoggerFunction('buildCategorieRestrictionTree');

export const useBuildCategorieRestrictionTree = () => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(BUILD_CATEGORIE_RESTRICTION_TREE, {
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.buildCategorieRestrictionTree?.map(decodeCategoryNames));
        }
    }, [data]);

    return {
        categories: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
